// Third Party
import Locale from '@/types/locale';
import ProposalFieldData from '@/types/proposal-field-data';
import React from 'react';

type Props = {
  field: ProposalFieldData;
  locale?: Locale;
  showBaseCurrencies?: boolean;
};

const ProposalField = ({ field, locale, showBaseCurrencies }: Props) => {
  const renderCell = () => {
    const { value, cellType, cellFormat, itemType, color, decimalPlace, withSuffixes, flags, currency } = field;

    return React.createElement(cellType, {
      value,
      locale,
      itemType,
      color,
      flags,
      showBaseCurrencies,
      currency,
      decimalPlace,
      withSuffixes,
      format: cellFormat,
    });
  };

  return (
    <div className="proposal-field" data-private data-dd-privacy="mask">
      <div className="proposal-field-container">
        <span>{field.label}</span>
        {renderCell()}
      </div>
    </div>
  );
};

export type ProposalFieldProps = Props;

export default ProposalField;
